export const NavigationId = {
  HOME: 'HOME',
  INCIDENTS: 'INCIDENTS',
  SERVICES: 'SERVICES',
  USERS: 'USERS',
  GROUPS: 'GROUPS',
  REPORTS: 'REPORTS',
  MESSAGING: 'MESSAGING',
  ADMIN: 'ADMIN',
  DEVELOPER: 'DEVELOPER',
};

export const CocoonMainMenuIdToMenuIdMap = {
  Admin: NavigationId.ADMIN,
  Groups: NavigationId.GROUPS,
  Messaging: NavigationId.MESSAGING,
  Reporting: NavigationId.REPORTS,
  Subscriptions: NavigationId.DEVELOPER,
  'Persons-Teams': NavigationId.USERS,
  Workflow: NavigationId.DEVELOPER,
};

export const CocoonSubMenuIdToHelpIdMap = {
  FindDynamicTeams: 'DynamicTeamsList',
  DynamicTeams: 'DynamicTeams',
  SearchWebServiceUsers: 'webServiceUserDetailsForm',
  WebServiceUserDetails: 'webServiceUserDetailsForm',
  CompanyHolidays: 'CompanyHolidaysList',
  CustomAttributes: 'CustomAttributes',
  CustomFields: 'CustomFields',
  CustomHolidays: 'CustomHolidaysList',
  PhoneRecordings: 'PhoneRecordingList',
  EditPhoneRecording: 'PhoneRecordingDetailForm',
  SelectSiteForSiteHoliday: 'SiteHolidaysList',
  AddPhoneRecording: 'AddPhoneRecording',
};

export const UserProfileHelpIdMap = {
  devices: 'UserDevicesPlace',
  groups: 'UserGroups',
  schedule: 'UserSchedulePlace',
  subscriptions: 'UserSubscriptionsPlace',
  supervisors: 'UserSupervisorsPlace',
  supervisedUsers: 'UsersSupervisedPlace',
};
